import { createLogger, createStore } from 'vuex';
import { auth } from './auth.module';
import { orders } from './orders.module';
import { socket } from './socket.module';
import { timeline } from './timeline.module';
import { version } from './version.module';

const store = createStore({
    namespaced: true,
    modules: {
        auth,
        orders,
        socket,
        timeline,
        version,
    },
    plugins: process.env.NODE_ENV !== 'production' ? [createLogger()] : [],
});

export default store;
